import { useQuery } from "@apollo/client/react";
import type {
  GetRelatedShowsQuery,
  GetRelatedShowsQueryVariables,
} from "@/codegen/graphql/generated/graphql";
import { CatalogShowFragment } from "@/codegen/graphql/fragments/CatalogShow.fragment";
import { useFragment } from "@/codegen/graphql/generated";
import { GET_RELATED_SHOWS } from "@/codegen/graphql/queries/GetRelatedShows.query";

/** The rail shows this many; View all is for the rest. */
export const RECOMMENDATIONS_RAIL_SIZE = 10;

// One query for the rail and View all, served from the cache the second
// time: the backend caps a series' recommendations well under this (the
// mobile spec says 10), so a bigger limit costs no more than the rail's own.
const LIMIT = 50;

/**
 * The series recommended next to `showId` (SHO-757). `relatedShows` is
 * @authenticated, so it is asked from the section, not the route loader.
 * `undefined` until answered, and with no `showId`.
 */
export default function useRelatedShows(showId: string) {
  const { data } = useQuery<
    GetRelatedShowsQuery,
    GetRelatedShowsQueryVariables
  >(GET_RELATED_SHOWS, {
    variables: { showId, limit: LIMIT },
    // The View all page asks before the series is in (a language switch
    // resets the store): `relatedShows(showId: "")` is an `Invalid show ID`
    // the ErrorLink would report.
    skip: !showId,
  });

  return useFragment(CatalogShowFragment, data?.relatedShows.shows);
}
